import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { timer } from 'rxjs';
import * as _moment from 'moment';
import { map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
const moment = _moment;
class TimeSinceComponent {
    constructor() { }
    ngOnChanges() {
        if (this.startDate) {
            this.timer$ = timer(0, 1000).pipe(map(() => this.formatTime()));
        }
    }
    ngOnInit() { }
    formatTime() {
        if (!this.startDate) {
            return '';
        }
        let duration = moment.duration(moment.utc().diff(moment.utc(this.startDate)));
        const days = Math.floor(duration.asDays());
        const hours = Math.floor(duration.asHours());
        const minutes = Math.floor(duration.asMinutes());
        if (days) {
            if (days > 1) {
                return `${days} days ago`;
            }
            return '1 day ago';
        }
        else if (hours) {
            if (hours > 1) {
                return `${hours} hours ago`;
            }
            return `1 hour ago`;
        }
        else if (minutes) {
            if (minutes > 1) {
                return `${minutes} mins ago`;
            }
            return `1 min ago`;
        }
        else {
            return `Just now`;
        }
    }
}
TimeSinceComponent.ɵfac = function TimeSinceComponent_Factory(t) { return new (t || TimeSinceComponent)(); };
TimeSinceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeSinceComponent, selectors: [["fgbcl-time-since"]], inputs: { startDate: "startDate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, template: function TimeSinceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, ctx.timer$), "\n");
    } }, pipes: [ɵngcc1.AsyncPipe], styles: [""] });
TimeSinceComponent.ctorParameters = () => [];
TimeSinceComponent.propDecorators = {
    startDate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeSinceComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-time-since',
                template: "<div>\r\n  {{ timer$ | async }}\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { startDate: [{
            type: Input
        }] }); })();

class TimeSinceModule {
}
TimeSinceModule.ɵfac = function TimeSinceModule_Factory(t) { return new (t || TimeSinceModule)(); };
TimeSinceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TimeSinceModule });
TimeSinceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TimeSinceModule, { declarations: function () { return [TimeSinceComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TimeSinceComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeSinceModule, [{
        type: NgModule,
        args: [{
                declarations: [TimeSinceComponent],
                imports: [CommonModule],
                exports: [TimeSinceComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TimeSinceComponent, TimeSinceModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-time-since.js.map